
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import _, { forEach } from "lodash";
import { ExamV2Custom } from "@/lib/model/exambuilder/exam-v2";
import {
  QuestionV2Object,
  QuestionV2
} from "@/lib/model/exambuilder/question-v2";
import QuestionCardV2 from "@/views/ai-builder/question-card-v2/question-group-select.vue";
import {
  StructRandomQuestionScoreConfig,
  StructExamRandomConfig
} from "@/lib/model/exambuilder/exam-v2";
import { EOF_TOKEN } from "html2canvas/dist/types/css/syntax/tokenizer";

interface Option {
  label: string;
  value: number | string;
  disabled?: boolean;
}

@Component({
  components: { QuestionCardV2 }
})
export default class TagEdit extends Vue {
  @Prop({}) exam!: ExamV2Custom;
  @Prop({}) visible!: boolean;
  @Prop({ type: Array, default: [new QuestionV2()] })
  questionList!: QuestionV2[];
  @Prop({ type: Object, default: () => ({}) }) questionIdMap!: any;
  @Prop({ type: StructExamRandomConfig, default: new QuestionV2() })
  questionGroup!: StructExamRandomConfig; //题目model
  @Prop({ type: Number, default: 0 }) index!: number;
  @Prop({ default: false, type: Boolean })
  setWeb!: boolean;

  groupForm = {
    name: "抽题组卷题",
    dimensionKeyList: "0",
    questionType: 0
  };
  pageSize = 10;
  pageNumber = 1;
  total = 0;
  paperList: QuestionV2[] = [];
  deleteVisible = false;
  groupDelText = "";
  groupName = "";
  deleteType = 0;
  questionTypeMap = {
    8: "音频题",
    7: "选择题",
    6: "视频题",
    5: "填空题",
    1: "选择题"
  };
  selectAll = false;
  questionTypeList: Option[] = [];
  typeKeyList: number[] = [];
  showQuestionList: QuestionV2[] = [];
  dimensionKeyList: string[] = [];
  selectedDimension: string[] = [];
  selectedQuestion: QuestionV2[] = [];
  sourceGroup: any = {};
  hasPaper = false;

  @Watch("visible", { immediate: true })
  show(nval: boolean) {
    if (nval) {
      this.sourceGroup = JSON.parse(JSON.stringify(this.questionGroup));
      this.groupForm.name = this.questionGroup.name || "抽题组卷题";
      this.initUseQuestion();
      this.showQuestionList.forEach(question => {
        if (this.questionGroup.questionIdList.includes(question.questionId)) {
          question.selected = true;
        } else {
          question.selected = false;
        }
        // this.showQuestionList.push(question);
      });
      this.dimensionKeyList = JSON.parse(
        JSON.stringify(this.exam.dimensionKeyList)
      );
      this.getQuestionInfo();
      this.selectItem();
      if (this.showQuestionList.length === this.selectedQuestion.length) {
        this.selectAll = true;
      }
      this.total = this.showQuestionList.length;
      if (this.showQuestionList.length > 10) {
        this.hasPaper = true;
      } else {
        this.hasPaper = false;
      }
      this.getList();
    }
  }

  handleSizeChange(pageSize: number) {
    this.pageSize = pageSize;
    this.getList();
  }

  handleCurrentChange(pageNumber: number) {
    this.pageNumber = pageNumber;
    this.getList();
  }

  getList() {
    console.log(this.showQuestionList);
    this.paperList = this.showQuestionList.slice(
      (this.pageNumber - 1) * this.pageSize,
      this.pageSize + (this.pageNumber - 1) * this.pageSize
    );
    this.total = this.showQuestionList.length;
  }

  // 初始化可用的questionlist
  initUseQuestion() {
    console.log(this.questionIdMap);
    const groupKeys = Object.keys(this.questionIdMap);
    const temp: number[] = [];
    groupKeys.forEach(key => {
      if (Number(key) != this.index) {
        temp.push(...this.questionIdMap[key]);
      }
    });
    this.questionList.forEach(question => {
      if (!temp.includes(question.questionId)) {
        this.showQuestionList.push(question);
      }
    });
    this.getList();
  }

  changeSelectAll(value: boolean) {
    if (value) {
      this.showQuestionList.forEach(el => {
        el.selected = true;
      });
    } else {
      this.showQuestionList.forEach(el => {
        el.selected = false;
      });
    }
    this.selectItem();
  }

  ok() {
    this.deleteType = 0;
    if (
      this.sourceGroup.questionList.length > 0 &&
      this.selectedQuestion.length === 0
    ) {
      this.groupDelText =
        "由于该分组下没有勾选题目，确认后系统将同时删除该题目分组的全部设置：";
      this.groupName = `组${this.index + 1}：${this.questionGroup.name ||
        "抽题组卷题"} ｜ ${this.questionGroup.questionList.length}抽${
        this.questionGroup.questionNumber
      } ｜ ${this.questionGroup.getQuestionTypeText()}`;
      this.deleteVisible = true;
      this.deleteType = 1;
    } else if (this.sourceGroup.questionNumber > this.selectedQuestion.length) {
      this.groupDelText =
        "系统将变更该题目分组的抽题数量，如有不妥请及时调整：";
      this.groupName = `组${this.index + 1}：${this.questionGroup.name ||
        "抽题组卷题"} ｜ ${this.questionGroup.questionList.length}抽${
        this.questionGroup.questionNumber
      } ｜ ${this.questionGroup.getQuestionTypeText()}`;
      this.deleteVisible = true;
    } else {
      this.submit();
    }
  }

  submit() {
    const dimensionScoreConfigList = this.selectedQuestion[0]?.dimensionListFilter.filter(
      el => this.selectedDimension.includes(el.dimensionKey)
    );
    const temp: StructRandomQuestionScoreConfig[] = [];
    if (dimensionScoreConfigList) {
      dimensionScoreConfigList.forEach(el => {
        const item = this.questionGroup.dimensionScoreConfigList.filter(
          item => item.dimensionKey === el.dimensionKey
        );
        const obj = new StructRandomQuestionScoreConfig();
        obj.backgroundColor = el.backgroundColor;
        obj.color = el.color;
        obj.dimensionKey = el.dimensionKey;
        obj.dimensionName = el.dimensionName;
        obj.dimensionScore = item.length > 0 ? item[0].dimensionScore : 0;
        temp.push(obj);
      });
    }
    this.$emit("ok", {
      questionList: this.selectedQuestion,
      questionIdList: this.selectedQuestion.map(el => el.questionId),
      questionType: this.selectedQuestion[0]?.questionType || 1,
      dimensionScoreConfigList: temp,
      name: this.groupForm.name,
      deleteType: this.deleteType
    });
    this.close();
  }

  resetFilter() {
    this.filterDimension([]);
    this.filterQuestionType([]);
    this.groupForm.dimensionKeyList = "0";
    this.groupForm.questionType = 0;
  }

  changeType(questionType: number | string) {
    if (questionType == 0) {
      const selectedQuestion = this.showQuestionList.filter(
        question => question.selected
      );
      // 选择题目的维度
      const dimensionKeyList: string[] = [];
      selectedQuestion.forEach(question => {
        dimensionKeyList.push(...question.dimensionKeyList);
      });
      if (selectedQuestion.length) {
        this.filterQuestionType([selectedQuestion[0].questionType]);
        this.filterDimension(
          this.helperEasyArray(dimensionKeyList) as string[]
        );
      } else {
        this.resetFilter();
      }
    } else {
      this.filterQuestionType([questionType as number], true);
      const dimensionList: string[] = [];
      this.showQuestionList.forEach(question => {
        question.dimensionKeyList.forEach(key => {
          if (
            !dimensionList.includes(key) &&
            this.exam.dimensionKeyList.includes(key)
          ) {
            dimensionList.push(key);
          }
        });
      });
      this.filterDimension(dimensionList);
    }
  }

  changeDim(key: string) {
    if (key === "0") {
      const selectedQuestion = this.showQuestionList.filter(
        question => question.selected
      );
      // 选择题目的类型
      const questionType = this.helperEasyArray(
        selectedQuestion.map(question => question.questionType)
      );
      // 选择题目的维度
      const dimensionKeyList: string[] = [];
      selectedQuestion.forEach(question => {
        dimensionKeyList.push(...question.dimensionKeyList);
      });
      if (selectedQuestion.length) {
        this.filterDimension(
          this.helperEasyArray(dimensionKeyList) as string[]
        );
        this.filterQuestionType(questionType as number[]);
      } else {
        this.resetFilter();
      }
    } else {
      this.filterDimension([key]);
      const questionType: number[] = [];
      this.showQuestionList.forEach(question => {
        if (
          question.dimensionKeyList.includes(key) &&
          !questionType.includes(question.questionType)
        ) {
          questionType.push(question.questionType);
        }
      });
      this.filterQuestionType(questionType);
    }
  }

  getQuestionInfo() {
    this.showQuestionList.forEach(el => {
      if (!this.typeKeyList.includes(el.questionType)) {
        this.typeKeyList.push(el.questionType);
        const label = this.questionTypeMap[el.questionType];
        this.questionTypeList.push({
          value: el.questionType,
          label,
          disabled: false
        });
      }
    });
  }

  // 过滤题目类型
  filterQuestionType(questionType: number[], flag?: boolean) {
    if (questionType.length > 0) {
      this.questionTypeList.forEach(el => {
        if (!questionType.includes(el.value as number)) {
          el.disabled = true;
        }
      });
      this.filterQuestion(questionType, "type");
    } else {
      this.questionTypeList.forEach(el => {
        el.disabled = false;
      });
      this.getQuestionInfo();
      this.showQuestionList = [];
      this.initUseQuestion();
    }
  }

  // 过滤维度
  filterDimension(dimensionList: string[]) {
    if (dimensionList.length > 0) {
      this.dimensionKeyList = dimensionList;
      this.filterQuestion(dimensionList, "dim");
    } else {
      this.dimensionKeyList = JSON.parse(
        JSON.stringify(this.exam.dimensionKeyList)
      );
      this.showQuestionList = [];
      this.initUseQuestion();
    }
  }

  // 过滤题目
  filterQuestion(keyList: string[] | number[], type: "type" | "dim") {
    if (type === "type") {
      // 根据类型过滤题目
      this.showQuestionList = this.showQuestionList.filter(
        el => el.questionType === keyList[0]
      );
    } else {
      // 根据维度过滤题目
      this.showQuestionList = this.showQuestionList.filter(el => {
        let flag = false;
        el.dimensionKeyList.forEach(key => {
          if (keyList.includes(key as never)) {
            flag = true;
          }
        });
        return flag;
      });
    }
    this.getList();
  }

  helperEasyArray(arr: string[] | number[]): string[] | number[] {
    // @ts-ignore
    return [...new Set(arr)];
  }

  selectItem() {
    // 选择的题目
    const selectedQuestion = this.showQuestionList.filter(
      question => question.selected
    );
    if (selectedQuestion.length === this.showQuestionList.length) {
      this.selectAll = true;
    } else {
      this.selectAll = false;
    }
    this.selectedQuestion = selectedQuestion;
    // 选择题目的类型
    const questionType = this.helperEasyArray(
      selectedQuestion.map(question => question.questionType)
    );
    // 选择题目的维度
    const dimensionKeyList: string[] = [];
    selectedQuestion.forEach(question => {
      dimensionKeyList.push(
        ...question.dimensionListFilter.map(el => el.dimensionKey)
      );
    });
    this.selectedDimension = dimensionKeyList;
    if (selectedQuestion.length) {
      this.filterQuestionType(questionType as number[]);
      this.filterDimension(this.helperEasyArray(dimensionKeyList) as string[]);
    } else {
      this.resetFilter();
    }
  }

  close() {
    this.$emit("update:visible", false);
  }
}
